import React, { useEffect } from "react";

import Main from '../components/TradingAssets/Main'
import TradingTools from "../components/TradingAssets/TradingTools";
import WhatToTrade from "../components/TradingAssets/WhatToTrade";
import Explore from "../components/TradingAssets/Explore";
import SimpleSteps from "../components/Home/SimpleSteps";

function TradingAssets () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="">
            <Main/>
            <TradingTools/>
            <WhatToTrade/>
            <Explore/>
            <SimpleSteps/>
        </div>
    );
}

export default TradingAssets;